import { DetailsCss } from "@/styles/typography";
import styled from "styled-components";

const Tag = styled.span<{ $color: string }>`
  ${DetailsCss}
  border-radius: 4px;
  padding: 10px 8px 8px;
  background-color: ${({ $color }) => $color};
  width: fit-content;
  color: ${({ $color, theme }) =>
    $color === "#534B93" ? theme.colors.coreLight : theme.colors.textHeading};

  @media print {
    display: none;
  }
`;

const S = {
  Tag,
};

export default S;
